var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"not-found"}},[_c('Header'),_c('h1',{staticClass:".heading"},[_vm._v("Resource Not Found!")]),_c('p',[_vm._v("Sorry, I could not find the resource you were looking for.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }